<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card
          color="green"
          icon="mdi-content-copy"
          title="Consignment stock"
          class="px-5 py-3"
        >
          <br />
          <v-text-field
            color="grey darken-1"
            label="Status"
            readonly
            :value="consignmentStock.status | getStockStatusName"
            prepend-icon="mdi-message"
          ></v-text-field>
          <!-- consignmentStock.status == 3 on error status, 4 - withoutClientInvoice status -->
          <v-text-field
            v-if="consignmentStock.status == 3 || consignmentStock.status == 4"
            color="grey darken-1"
            label="Error message"
            readonly
            :value="consignmentStock.errorMessage"
            prepend-icon="mdi-message"
          ></v-text-field>
          <v-text-field
            color="grey darken-1"
            v-model="consignmentStock.customer.name"
            label="Customer"
            readonly
            prepend-icon="mdi-account"
          />
          <v-row>
            <v-col cols="6">
              <v-text-field
                color="grey darken-1"
                v-model="consignmentStock.start"
                label="Start"
                prepend-icon="mdi-calendar"
                readonly
                name="start date"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6">
              <v-text-field
                v-model="consignmentStock.end"
                label="End"
                prepend-icon="mdi-calendar"
                readonly
                color="grey darken-1"
              ></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-expand-transition>
            <v-list two-line>
              <v-list-item v-for="(pq, i) in consignmentStock.items" :key="i" style="padding: 0px">
                <v-list-item-content>
                  <v-row justify="space-around">
                    <v-col cols="5" class="noBottomTopPaddings">
                      <v-list-item-subtitle>Product</v-list-item-subtitle>
                      <br />
                      <v-list-item-title
                        class="topPaddingText"
                        v-text="pq.product.name + ' - ' + pq.product.articleNumber"
                      ></v-list-item-title>
                    </v-col>

                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>Quantity</v-list-item-subtitle>
                      <br />
                      <v-list-item-title v-text="pq.quantity" class="topPaddingText"></v-list-item-title>
                    </v-col>
                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>Synced</v-list-item-subtitle>
                      <br />
                      <div class="topPaddingIcon">
                        <v-icon
                          v-if="pq.quantitySyncedWithERP"
                          color="green"
                        >mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="red">mdi-close-circle</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>Returned</v-list-item-subtitle>
                      <br />
                      <v-list-item-title v-text="pq.returnedQuantity" class="topPaddingText"></v-list-item-title>
                    </v-col>
                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>Synced</v-list-item-subtitle>

                      <div class="topPaddingIcon">
                        <br />
                        <v-icon
                          v-if="pq.returnedQuantitySyncedWithERP"
                          color="green"
                        >mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="red">mdi-close-circle</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>
                        Invoiced/
                        <br />Ordered
                      </v-list-item-subtitle>
                      <div class="topPaddingIcon">
                        <v-icon v-if="pq.invoiced" color="green">mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="red">mdi-close-circle</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1" class="noPaddings" align="center">
                      <v-list-item-subtitle>Finished</v-list-item-subtitle>
                      <br />
                      <div class="topPaddingIcon">
                        <v-icon v-if="pq.finished" color="green">mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else color="red">mdi-close-circle</v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expand-transition>
          <br />
          <v-row justify="center">
            <v-card-actions class="pl-0">
              <v-btn color="info" min-width="100" @click="goBack()">Return</v-btn>
            </v-card-actions>
            <!-- consignmentStock.status == 2 on status closed -->
            <v-card-actions class="pl-0" v-if="consignmentStock.status == 2">
              <v-btn color="error" min-width="100" @click="deleteDialog = true">Delete</v-btn>
            </v-card-actions>
            <!-- consignmentStock.status == 4 on status withoutClientInvoice -->
            <v-card-actions class="pl-0" v-if="consignmentStock.status == 4">
              <v-btn
                color="success"
                min-width="100"
                @click="createOrderDialog = true"
              >Create client invoice/order</v-btn>
            </v-card-actions>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="deleteDialog = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteStock()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="createOrderDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">Create client invoice/order</v-card-title>
        <v-card-text class="noBottomTopPaddings">
          <v-container>
            <v-row justify="center">
              <v-col>
                <v-text-field
                  v-model="consignmentStock.discount"
                  label="Discount %"
                  name="discount"
                  :hint="errors.first('discount')"
                  @keypress="onlyDecimal"
                  data-vv-as="discount"
                  v-validate="'between:0,100'"
                  :error="getError('discount')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="noBottomTopPaddings">
          <v-btn color="orange" text @click="createOrderDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createOrder(true)">Create invoice</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="createOrder(false)">Create order</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import router from "../../../router";
import axios from "../../../utils/axios";
import { onlyDecimal } from "../../../helpers/inputHelper";
import {
  getErrorMessageFromException,
  getErrorMessageFromValidation
} from "../../../helpers/errorHelper";

export default {
  name: "ConsignmentStocksActiveEdit",
  data: () => ({
    consignmentStock: {
      id: 0,
      errorMessage: String,
      totalValue: 0,
      totalInValue: 0,
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10),
      status: 0,
      discount: String,
      customer: {
        id: null,
        name: String
      },
      items: []
    },
    consignmentStockReturnInfo: {
      consignmentStockId: 0,
      discount: 0,
      invoiceOnly: false
    },

    snackbar: false,
    message: "",
    snackColor: "error",

    deleteDialog: false,
    createOrderDialog: false
  }),

  created() {
    this.getConsignmentStock();
  },

  methods: {
    async getConsignmentStock() {
      let loader = this.$loading.show();
      try {
        var result = await axios.get(
          "/ConsignmentStock/" + this.$route.params.id
        );
        if (result) {
          this.consignmentStock = result.data;
          this.consignmentStock.start = new Date(result.data.start)
            .toISOString()
            .substr(0, 10);
          this.consignmentStock.end = new Date(result.data.end)
            .toISOString()
            .substr(0, 10);
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = getErrorMessageFromException(exception);
        this.snackColor = "error";
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },

    async deleteStock() {
      this.deleteDialog = false;
      let loader = this.$loading.show();
      try {
        var result = await axios.delete(
          "/ConsignmentStock/" + this.$route.params.id
        );
        if (result) {
          this.$router.go(-1);
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = getErrorMessageFromException(exception);
        this.snackColor = "error";
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },

    async createOrder(invoiceOnly) {
      let loader = this.$loading.show();
      this.deleteDialog = false;
      try {
        this.consignmentStockReturnInfo.consignmentStockId = this.consignmentStock.id;
        this.consignmentStockReturnInfo.discount = this.consignmentStock.discount;
        this.consignmentStockReturnInfo.invoiceOnly = invoiceOnly;

        var result = await axios.put(
          "/ConsignmentStock/CreateClientOrder",
          this.consignmentStockReturnInfo
        );
        if (result) {
          this.$router.go(-1);
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = getErrorMessageFromException(exception);
        this.snackColor = "error";
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    onlyDecimal($event) {
      onlyDecimal($event, this.consignmentStock.discount);
    },

    getError(fieldName) {
      if (this.errors.first(fieldName) !== undefined) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style>
.noPaddings {
  padding: 0px !important;
}
.noBottomTopPaddings {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.topPaddingIcon {
  padding-top: 2px !important;
}
.topPaddingText {
  padding-top: 4px !important;
}
</style>